import { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../api';

const PreferencesContext = createContext(null);

export function PreferencesProvider({ children }) {
  const [filters, setFilters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getPreferences()
      .then(d => setFilters(d.filters || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  async function updateFilters(newFilters) {
    setFilters(newFilters);
    await api.updatePreferences(newFilters);
  }

  return (
    <PreferencesContext.Provider value={{ filters, loading, updateFilters }}>
      {children}
    </PreferencesContext.Provider>
  );
}

export const usePreferences = () => useContext(PreferencesContext);
